module.exports = __webpack_public_path__ + "a40a5c258732ebb61dc08d095d3f4087.woff2";